import React from 'react'

const ViewProductDetailInBooking = () => {
  return (
    <>
     <div className="">
  <div className="TitleBox mb-2">
    <h2>Booking Management</h2>
  </div>
  <div className="OrderDetails">
    <h5>Booking Details</h5>
    <article>
      <aside>
        <p>
          <label>Booking Number</label>
          <span />
        </p>
        <p>
          <label>Placed On</label>
          <span>2025-05-16</span>
        </p>
      </aside>
      <aside>
        <p>
          <label>Payment Status</label>
          <span>Pending</span>
        </p>
        <p>
          <label>Total Amount</label>
          <span>Rs.8298</span>
        </p>
      </aside>
    </article>
  </div>
  <div className="OrderDetails">
    <h5>Customer Details</h5>
    <article>
      <aside>
        <p>
          <label>Customer Id</label>
          <span>681dfcf4533cb3357858f892</span>
        </p>
        <p>
          <label>Customer Name</label>
          <span>Sakshi Singh</span>
        </p>
      </aside>
      <aside>
        <p>
          <label>Customer Contact Details</label>
          <span>8882191869</span>
        </p>
      </aside>
    </article>
  </div>
  <div className="OrderDetails">
    <h5>Item(s) List</h5>
    <article>
      <aside>
        <p>
          <label>Name of the product</label>
          <span />
        </p>
      </aside>
      <aside>
        <p>
          <label>Qty</label>
          <span />
        </p>
      </aside>
    </article>
  </div>
  <div className="OrderDetails">
    <h5>Venue Address</h5>
    <article>
      <aside>
        <p>
          <label>Full Name</label>
          <span>Sakshi Singh</span>
        </p>
        <p>
          <label>Mobile Number </label>
          <span className="w-75 d-inline">+91 8882191869</span>
        </p>
        <p>
          <label>Address</label>
        </p>
        <div>
          <p style={{ width: 400 }}>House Number/Flat No./Office No. : </p>
          <p style={{ width: 400 }}>Road name, Area Name, Society Name : ,</p>
          <p style={{ width: 400 }}>City, Region, Country : </p>
          <p style={{ width: 400 }}>Pin Code : </p>
        </div>
        <p />
      </aside>
    </article>
  </div>
  <div className="OrderDetails">
    <h5>Price Details</h5>
    <article>
      <aside>
        <p>
          <label>Total Amount</label>
          <span>Rs. 8298</span>
        </p>
        <p>
          <label>GST</label>
          <span>18%</span>
        </p>
        <p />
        <hr />
        <p>
          <label>You Pay</label>
          <span>Rs. 8298</span>
        </p>
      </aside>
    </article>
  </div>
  <div className="OrderDetails">
    <h5>Questions</h5>
    <article>
      <aside>
        <p style={{ width: "100%" }}>
          <label>Where do you want us to do the decoration?* (Max 1)</label>
          <span />
        </p>
        <p>
          <label>How did you come to know about Skyrixe?</label>
          <span />
        </p>
        <p>
          <label>What is the occasion?</label>
          <span />
        </p>
        <p>
          <label>Select Ballons color(Max 3)</label>
          <span />
        </p>
        <p>
          <label>Additional Phone Number</label>
          <span />
        </p>
        <p>
          <label>
            Mention the age or anniversary year for foil balloons? (Max 2)
          </label>
          <span />
        </p>
        <p>
          <label>Select the color of the age balloon or foil balloon?</label>
          <span />
        </p>
        <p>
          <label>Customer Requirement</label>
          <span />
        </p>
      </aside>
    </article>
  </div>
  <div className="ModalBox">
    
  </div>
</div>
 
    </>
  )
}

export default ViewProductDetailInBooking
